
export enum EnumOrderMode {
    NEWEST = 0,
    HIGHEST_PRICE = 1,
    LOWEST_PRICE = 2,
    MOST_RELEVANT = 4,
    CUSTOM_ORDER_MODE = 6,
}

